<script>
export default {};
</script>

<template>
	<div v-show="oidcUser" id="app">
		<RouterView :key="$route.fullPath" />
		<portal-target name="semantic-ui-vue" />
		<notifications position="bottom right" class="mystyles" />
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
	methods: {
		...mapActions('oidc', ['signOutOidc']),
		...mapActions('configuraciones', ['obtener']),
		accessTokenExpired: function() {
			this.signOutOidc();
		},
		userLoaded: function() {
			setTimeout(this.obtener, 200);
		}
	},
	computed: {
		...mapGetters('oidc', ['oidcUser'])
	},
	mounted() {
		window.addEventListener(
			'vuexoidc:accessTokenExpired',
			this.accessTokenExpired
		);
		window.addEventListener('vuexoidc:userLoaded', this.userLoaded);
	},
	destroyed() {
		window.removeEventListener(
			'vuexoidc:accessTokenExpired',
			this.accessTokenExpired
		);
		window.removeEventListener('vuexoidc:userLoaded', this.userLoaded);
	}
};
</script>
<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.yarb
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';

*,
*::before,
*::after {
	box-sizing: border-box;
}

body {
	background: $color-body-bg !important;
}
#app {
	@extend %typography-small;
}

// ===
// Base element styles
// ===

a,
a:visited {
	color: $color-link-text;
}

h1 {
	@extend %typography-xxlarge;
}

h2 {
	@extend %typography-xlarge;
}

h3 {
	@extend %typography-large;
}

h4 {
	@extend %typography-medium;
}

h5,
h6 {
	@extend %typography-small;
}

// ===
// Vendor
// ===

#nprogress .bar {
	background: $color-link-text;
}

#nprogress .spinner {
	display: none;
}

.mystyles {
	color: #fff;
	.primary {
		background: $background-primary !important;
		border-left-color: $background-primary-hover !important;
	}

	.warn {
		background: $background-warning !important;
		border-left-color: $background-warning-hover !important;
	}

	.error {
		background: $background-danger !important;
		border-left-color: $background-danger-hover !important;
	}

	.success {
		background: $background-success !important;
		border-left-color: $background-success-hover !important;
	}

	.info {
		background: $background-primary !important;
		border-left-color: $background-primary-hover !important;
	}
}

#app .ui.basic.red.button,
#app .ui.basic.red.buttons .button {
	color: #9f2241 !important;
	-webkit-box-shadow: 0 0 0 1px #9f2241 inset !important;
	box-shadow: 0 0 0 1px #9f2241 inset !important;
}

#app .ui.fullscreen.modal {
	left: auto !important;
}

#app eq {
	font-size: 1.5em !important;
}
</style>
